import styles from './styles/Navigation.module.css';

const Navigation = ({ sectionRefs, activeSection }) =>
{
    return (
        <div className={styles.container}>
            <a
                href="#about"
                onClick={(e) =>
                {
                    e.preventDefault();
                    sectionRefs['about'].current?.scrollIntoView({
                        behavior: 'smooth'
                    });
                }}
            >
                <img src={`${process.env.PUBLIC_URL}/image/icon.png`} className={styles.icon} alt="Navigation Icon" />
            </a>
            <div className={styles.itemsContainer}>
                {Object.keys(sectionRefs).map((section) => (
                    <Item section={section} activeSection={activeSection} sectionRefs={sectionRefs} />
                ))}
            </div>
        </div>
    )
}

export default Navigation;

const Item = ({ section, activeSection, sectionRefs }) =>
{
    return (
        <a
            className={styles.item}
            href={`#${section}`}
            style={{ color: activeSection === section ? '#075985' : '#0891B2' }}
            onClick={(e) =>
            {
                e.preventDefault();
                sectionRefs[section].current?.scrollIntoView({
                    behavior: 'smooth'
                });
            }}
        >
            {section}
            <div
                className={styles.underline}
                style={{
                    display: (activeSection === section) ? 'block' : 'none',
                    backgroundColor: (activeSection === section) ? '#075985' : '#0891B2'
                }}
            >
            </div>
        </a>
    )
}